import { GripVertical } from "lucide-react"

import { Icon, IconSizes } from "../../../../components/Icon"
import { classNames } from "../../../../lib/classNames"
import { FloatingTooltip } from "../../../base/overlay/FloatingTooltip"
import { useSortableRow } from "../../SortableRows/SortableRowsProvider"
import { TableCell, TableCellProps, TableCellWidth } from "../TableCell"

export interface TableDragHandleCellProps
  extends Omit<TableCellProps, "children" | "width"> {
  rowKey: string
  isDisabled?: boolean
  disabledMessage?: string
}

export function TableDragHandleCell({
  className,
  rowKey,
  isDisabled = false,
  disabledMessage,
  ...otherProps
}: TableDragHandleCellProps) {
  const { dragHandleProps } = useSortableRow({ id: rowKey })

  const icon = (
    <Icon
      icon={GripVertical}
      size={IconSizes.ExtraSmall}
      className={
        isDisabled
          ? "text-v2-foreground-default-disabled cursor-not-allowed"
          : "text-v2-foreground-default-weak cursor-grab"
      }
    />
  )

  return (
    <TableCell
      width={TableCellWidth.ExtraExtraSmall}
      onClick={(e) => e.stopPropagation()}
      className={classNames("cursor-default border-r-0", className)}
      {...(isDisabled ? {} : dragHandleProps)}
      {...otherProps}
    >
      {isDisabled && disabledMessage ? (
        <FloatingTooltip
          trigger={icon}
          content={disabledMessage}
          placement="right"
          portal
        />
      ) : (
        icon
      )}
    </TableCell>
  )
}
